/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useMeasurementSocket } from "../../hooks/useMeasurementCheck";
import { WrapperContext } from "../../context/WrapperContext";
import { AttributesContext } from "../../context/AttributesContext";
import { CUSTOM_STORE } from "../../services/constant";
import { getEndpointFitViewCustomReScan } from "../../utils/Utils";
import SwanLogo from "../SwanLogo";

const CustomMeasurementText = ({ link, textToShow = "", isInProgress }) => {
	const { scanId, shopifyRedirectUrl, email, resetButton } = useContext(WrapperContext);
	const { attributesData } = useContext(AttributesContext);
	const { shopDomain, product, name, callbackUrl } = attributesData ?? {};
	const [isProgress, setIsProgress] = useState(isInProgress);
	const [redirectLink, setRedirectLink] = useState(link);
	const [buttonText, setButtonText] = useState(textToShow);
	const handleWebsocket = useMeasurementSocket();

	const handleLink = useCallback(() => {
		if (redirectLink) {
			window.location.href = redirectLink;
		}
	}, [redirectLink]);

	const onSucess = useCallback(
		(data) => {
			if (data && data?.scanStatus==="success" && data?.resultType==="intermediate" && data?.code === 200 ) {
				return;
			}
			if (CUSTOM_STORE[shopDomain]) {
				setRedirectLink(
					getEndpointFitViewCustomReScan({
						productHandle: product?.handle,
						shopDomain,
						shopifyRedirectUrl,
						email,
						name,
						scanID: scanId,
						callbackUrl,
					}),
				);
			}
			setButtonText("");
			setIsProgress(false);
			console.log(data, "success");
		},
		[callbackUrl, email, name, product?.handle, scanId, shopDomain, shopifyRedirectUrl],
	);

	const onError = useCallback(
		(data) => {
			console.log(data, "error");
			resetButton();
		},
		[resetButton],
	);

	useEffect(() => {
		if (isProgress) {
			handleWebsocket({ scanId, onSucess, onError });
		}
	}, []);

	return (
		<button
			disabled={isProgress}
			onClick={handleLink}
			className="w-full flex items-center py-3 px-4 bg-white text-left text-gray-900 border border-gray-200 rounded-xl font-medium hover:bg-gray-50 cursor-pointer transition-colors"
		>
			<picture className="relative h-[32px] w-[32px] rounded-md overflow-hidden flex-shrink-0 flex items-center justify-center">
				<SwanLogo />
			</picture>
			<aside className="w-[calc(100%-32px)] pl-[20px]">
				<h4 className="text-[16px] font-medium">{buttonText || "Measurements Saved"}</h4>
				<p className="text-[14px] text-gray-500">Swan</p>
			</aside>
		</button>
	);
};

export default CustomMeasurementText;
